const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');
const EntityFilter = require('./EntityFilter');

class Question extends BaseModel {
  static basePath = '/api/v1/questions';
  static dataType = 'question';

  constructor(json) {
    super(json);
    this.parseChildren(['entity']);
  }

  static replaceAttachment(questionId, value) {
    let path = `${this.basePath}/${questionId}/attachment`;
    let body = { value };

    if (value instanceof File) {
      body = new FormData();
      body.append('value', value);
    }

    return new HTTPClient().put(path, body).then(this.prototype.constructor._parseDataItem.bind(this));
  }

  static removeAttachment(questionId) {
    let path = `${this.basePath}/${questionId}/attachment`;

    return new HTTPClient().delete(path).then(this.prototype.constructor._parseDataItem.bind(this));
  }

  static conditionsPathFor(typ, id) {
    return(`${this.basePath}/${id}/${typ}-conditions`);
  }

  static getAnswerConditions(questionId) {
    return (EntityFilter.list({ path: this.conditionsPathFor('answer', questionId) }));
  }

  static deleteAnswerConditions(questionId) {
    return (EntityFilter.delete(null, { path: this.conditionsPathFor('answer', questionId) }));
  }

  static updateAnswerConditions(questionId, filters) {
    return (EntityFilter.create(filters, { path: this.conditionsPathFor('answer', questionId) }));
  }

  static getContactConditions(questionId) {
    return (EntityFilter.list({ path: this.conditionsPathFor('contact', questionId) }));
  }

  static deleteContactConditions(questionId) {
    return (EntityFilter.delete(null, { path: this.conditionsPathFor('contact', questionId) }));
  }

  static updateContactConditions(questionId, filters) {
    return (EntityFilter.create(filters, { path: this.conditionsPathFor('contact', questionId) }));
  }
}

BaseModel.models[Question.dataType] = Question;
module.exports = Question;
